import React from 'react';
import ProductEditContainer from '../../containers/productmng/ProductEditContainer';

const ProductEditPage = () => {
  return <ProductEditContainer />;
};

export default ProductEditPage;
